/* Core & libraries */
import React, { Suspense, useState } from 'react';
import { useTheme } from 'react-jss';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { storageFactory } from 'factory/storageFactory';

/* Helpers, constants, custom methods, internal libraries */
import { useLocaleContext } from '../../contexts/localeContext';
import { useGlobalContext } from '../../contexts/globalContext';
import { API_HOST, API_PROTOCOL } from '../../constants/appConstants';
import { lazyWithPreload } from '../../helpers/lazyLoadingHelpers';
import { useFormatLocale } from '../../hooks/useFormatLocale';

/* Components */
import { ReactComponent as SignOutIcon } from '../../resources/images/logout.svg';
import { getFullLanguageText } from '../../helpers/general';
import SpinnerBasic from '../../components/spinners/SpinnerBasic';
const CountryLanguageModalLazy = lazyWithPreload(() => import('../../components/modals/countryLanguageModal'));
import FlagIconComponent from '../flagIconComponent';

/* Styles */
import styles from './styles';
import generalStyles from "../../resources/styles/general";

const localStore = storageFactory(() => localStorage);

const EscalationHeader = ({ hideSignOut }) => {
  const theme = useTheme();
  const classes = styles({ theme });
  const general = generalStyles({ theme });
  const locale = useLocaleContext();
  const { locales } = useFormatLocale();

  const logout = () => {
    const LOGOUT_URL = "oidc/logout.html"
    window.location.href = `${API_PROTOCOL}://${API_HOST}/${LOGOUT_URL}`;
    localStore.removeItem("showAuthorisedCityUsersModal")
    localStore.removeItem("maintenanceMode")
  };

  const [showLanguageModal, setShowLanguageModal] = useState(false);
  const { authenticated } = useGlobalContext();

  return (
    <div className={`${general.main} ${classes.lang}`}>
      <div>
        <div
          tabIndex="0"
          onClick={() => setShowLanguageModal(true)}
          className={classes.overlayLink}
          data-testid={'langselector'}
        >
          <FlagIconComponent locale={locale} flagClassName={classes.flagStyle}/>
          <div className={classes.locale}>{getFullLanguageText(locale)}</div>
        </div>
      </div>
      {!hideSignOut && (
        <div>
          <Link onClick={logout} className={classes.overlayLinkSignOut}>
            <SignOutIcon className={classes.popoverImage} />
            <FormattedMessage id="navigation.signOut" />
          </Link>
        </div>
      )}
      <Suspense fallback={showLanguageModal ? <SpinnerBasic /> : null}>
        {showLanguageModal && (
          <CountryLanguageModalLazy showModal={showLanguageModal} setShowModal={setShowLanguageModal} locales={locales}/>
        )}
      </Suspense>
    </div>
  );
};

export default EscalationHeader;
